export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125_0503_CBYM1530.883013b9.jpg";